import React, { useEffect, useState } from 'react';
import leaderKing1 from "../../../../src/template/images/Medal.png";
import leaderKing2 from "../../../../src/template/images/Medal2.png";
import leaderKing3 from "../../../../src/template/images/Medal3.png";

import leaderKing from "../../../../src/template/images/MedalAll.png";

import axiosInstance from "../../../util/axiosInstance";
import { Apiurl } from "../../../util/apiurl";
import { useNavigate, useParams  } from "react-router-dom";

function QuizLeaderboard() {
  const { id, topic } = useParams();
 
  const navigate = useNavigate();

  const [leaders, setLeaders] = useState([]);
  const handleSignUp = () => {
    navigate(`/SignUp/${id}/${topic}`);
  };
  const handleLogIn = () => {
    navigate(`/LogInQuiz/${id}/${topic}`);
  };

  useEffect(() => {
    fetchData();
  }, []);
  
  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(`${Apiurl.leaderboardlist}/leaderboard?topicId=${id}`);
      console.log(response.data, "leader board");
      setLeaders(response.data);
    } catch (error) {
      console.error("Error fetching leaderboard data: ", error);
    }
  };

  return (
    <div className="leader-board-section">
      <h4>Leader board</h4>
      <div className="auth-section">
        <button className='sign-up-btn' onClick={() => handleSignUp()}>Sign up</button> <span>to Join the leader board</span>
        <div className="or-line">OR</div>
        <button className='log-in-btn' onClick={() => handleLogIn()}>Login</button> <span>to View live leader board</span>
      
      </div>
      {leaders.map((leader, index) => (
        <div key={index} className="leader-row">
          <div className='leader-left'>
            <span className="leader-number">{index + 1}</span>
            <span className="leader-info">
              <span className="leader-img">{leader.userImage}</span>
              <span className="leader-name-post">
                <span className="leader-name">{leader.username}</span>
                <span className="user-points">{leader.score} points in {leader.timeTaken} seconds</span>
              </span>
            </span>
          </div>
          <div>
            {/* {index === 0 && <span><img src={leaderKing} alt="leader" /></span>} */}
             {index === 0 && <span><img src={leaderKing1} alt="leader" /></span>} 
             {index === 1 && <span><img src={leaderKing2} alt="leader" /></span>} 
             {index === 2 && <span><img src={leaderKing3} alt="leader" /></span>} 
             {index > 2 && <span><img src={leaderKing} alt="leader" /></span>} 
            
           
          </div>
        </div>
      ))}
      {leaders.length === 0 && <div>No Record Found !</div>}
    </div>
  );
}

export default QuizLeaderboard;
